<div class="flex flex-wrap mt-4 min-w">
    <h1 class="w-full">Análisis de noticias</h1>

    <h3 class="w-full">
        <p>Con esta herramienta usted podrá analizar la información publicada en las páginas de noticias en Español de
            su elección.</p>
        <p>Según la fuente de la noticia, podemos analizar el contenido del artículo, los comentarios o el texto
            completo que aparece en la página.</p>

        <div class="flex flex-wrap">
            <div class="card">
                <a href="http://www.cubadebate.cu/">
                    <img src="../../../../assets/img/cubadebate.jpg" alt="cubadebate" class="img-processed-source">
                </a>
                <h2>Cubadebate</h2>
                <ul>
                    <li>
                        <input type="checkbox" id="cb11" checked disabled class="cb-checked">
                        <label for="cb11">&nbsp; Artículo</label><br>
                    </li>
                    <li>
                        <input type="checkbox" id="cb12" checked disabled class="cb-checked">
                        <label for="cb12">&nbsp; Comentarios</label><br>
                    </li>
                    <li>
                        <input type="checkbox" id="cb13" disabled class="cb-unchecked">
                        <label for="cb13" class="text-gray">&nbsp; Texto completo</label><br>
                    </li>
                </ul>
            </div>

            <div class="card">
                <a href="https://actualidad.rt.com/">
                    <img src="../../../../assets/img/russia-today.png" alt="rt" class="img-processed-source">
                </a>
                <h2>Russia Today</h2>
                <ul>
                    <li>
                        <input type="checkbox" id="cb21" checked disabled class="cb-checked">
                        <label for="cb21">&nbsp; Artículo</label><br>
                    </li>
                    <li>
                        <input type="checkbox" id="cb22" disabled class="cb-unchecked">
                        <label for="cb22" class="text-gray">&nbsp; Comentarios</label><br>
                    </li>
                    <li>
                        <input type="checkbox" id="cb23" disabled class="cb-unchecked">
                        <label for="cb23" class="text-gray">&nbsp; Texto completo</label><br>
                    </li>
                </ul>
            </div>

            <div class="card">
                <a href="https://www.telesurtv.net/">
                    <img src="../../../../assets/img/telesur.png" alt="telesur" class="img-telesur">
                </a>
                <ul>
                    <li>
                        <input type="checkbox" id="cb31" checked disabled class="cb-checked">
                        <label for="cb31">&nbsp; Artículo</label><br>
                    </li>
                    <li>
                        <input type="checkbox" id="cb32" disabled class="cb-unchecked">
                        <label for="cb32" class="text-gray">&nbsp; Comentarios</label><br>
                    </li>
                    <li>
                        <input type="checkbox" id="cb33" disabled class="cb-unchecked">
                        <label for="cb33" class="text-gray">&nbsp; Texto completo</label><br>
                    </li>
                </ul>
            </div>

            <div class="card">
                <img src="../../../../assets/img/web-page.png" alt="of" class="img-other-source">
                <h2>Otra fuente</h2>
                <ul>
                    <li>
                        <input type="checkbox" id="cb41" disabled class="cb-unchecked">
                        <label for="cb41" class="text-gray">&nbsp; Artículo</label><br>
                    </li>
                    <li>
                        <input type="checkbox" id="cb42" disabled class="cb-unchecked">
                        <label for="cb42" class="text-gray">&nbsp; Comentarios</label><br>
                    </li>
                    <li>
                        <input type="checkbox" id="cb43" checked disabled class="cb-checked">
                        <label for="cb43">&nbsp; Texto completo</label><br>
                    </li>
                </ul>

            </div>
        </div>



        <p>Entre la información extraída, reconocerá las entidades mencionadas como posibles lugares, organizaciones y
            personas. Además, se muestran los temas tratados y el resultado del análisis de sentimiento que le permitirá
            conocer el nivel emocional de lo expresado en el artículo o los comentarios, según sea el caso.</p>

        <p>Este análisis se construye utilizando modelos cuya precisión es menor a la que podría dar un humano, por lo
            que sus resultados pueden mejorarse constantemente después de que el usuario final los evalúe. Esta es una
            herramienta de apoyo al trabajo de quienes realizan análisis sobre diversas fuentes y tipos de información;
            no está destinado a reemplazarlos 🤗</p>
    </h3>

    <form *ngIf="providerInfoForm !== undefined" name="provider-info" class="flex-auto px-20"
        [formGroup]="providerInfoForm">
        <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="url">
                URL de la noticia
            </label>
            <input type="url" name="news-url"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="URL..." formControlName="purl" required />
            <div *ngIf="providerInfoForm !== undefined && providerInfoForm.controls['purl'].invalid && (providerInfoForm.controls['purl'].dirty || providerInfoForm.controls['purl'].touched)"
                class="alert alert-danger">

                <div *ngIf="providerInfoForm.controls['purl'].errors?.required">
                    La URL debe ser especificada.
                </div>
            </div>
        </div>

        <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="token_compai">
                Token de CompAI
            </label>
            <input type="password" name="token-compai"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Token ..." formControlName="ptoken_compai" required />
            <div *ngIf="providerInfoForm !== undefined && providerInfoForm.controls['ptoken_compai'].invalid && (providerInfoForm.controls['ptoken_compai'].dirty || providerInfoForm.controls['ptoken_compai'].touched)"
                class="alert alert-danger">

                <div *ngIf="providerInfoForm.controls['ptoken_compai'].errors?.required">
                    El token de CompAI debe ser especificado.
                </div>
            </div>

            <div *ngIf="tokenHasError[0]" class="alert alert-danger">
                <div>{{tokenHasError[1]}}</div>
            </div>
        </div>

        <div class="text-center mt-6">
            <button
                class="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="submit" (click)="processArticleAsync()">
                <span *ngIf='!isProcessingArticle'>Procesar</span>

                <span *ngIf='isProcessingArticle'>
                    Procesando
                    <span *ngIf='progressInfo === undefined'>...</span>
                    <span *ngIf='progressInfo !== undefined && progressInfo.total > 0'> [ {{progressInfo.current}} /
                        {{progressInfo.total}} ]</span>
                </span>
            </button>
            <div *ngIf="progressInfo.description">[{{progressInfo.description}}]</div>
            <div *ngIf='isProcessingArticle && progressInfo.position !== null && !myIsNaN(progressInfo.position)'>
                [Hay {{progressInfo.position + 1}} tarea{{progressInfo.position === 0?'':'s'}} en cola antes de que
                comience la suya.]
            </div>
            <div *ngIf="hasErrorProcessing[0]" class="alert alert-danger">
                <div>{{hasErrorProcessing[1]}}</div>
            </div>
        </div>
    </form>

    <div class="w-full mb-12 px-4" [hidden]='!showResults'>
        <section>
            <h2>Artículo</h2>

            <!--TODO Poner el resument del artículo 
                <h3>Resumen</h3>
                <p>{{summary}}</p> 
            -->

            <h3>Tópico: {{topic}} (Prob. {{topicScore}})</h3>

            <!-- ENTIDADES -->
            <div class="w-full mb-12 ">
                <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
                    <div class="rounded-t mb-0 px-4 py-3 border-0">
                        <div class="flex flex-wrap items-center">
                            <div class="relative w-full  max-w-full flex-grow flex-1">
                                <h3 class="font-semibold text-lg text-blueGray-700">
                                    Entidades
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="block w-full overflow-x-auto">
                        <!-- Projects table -->
                        <table class="items-center w-full bg-transparent border-collapse">
                            <thead>
                                <tr>
                                    <th
                                        class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                                        Tipo
                                    </th>
                                    <th
                                        class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100">
                                        Valores
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let type of nerTypes">
                                    <th
                                        class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left flex items-center">
                                        <span class="ml-3 font-bold text-blueGray-600">
                                            {{type[2]}}
                                        </span>
                                    </th>
                                    <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-sm p-4">
                                        {{join(', ', type[1])}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>

            <!-- include toxicity and keywords -->

        </section>

        <app-dependency-dashboard [type]='"entities"' [nodes]='nodes' [edges]='edges'></app-dependency-dashboard>

        <div style="margin-top: 30px;"></div>

        <app-dependency-dashboard [type]='"topics"' [nodes]='nodesTopics' [edges]='edgesTopics'>
        </app-dependency-dashboard>
    </div>

    <div class="w-full mb-12 px-4" [hidden]='!showResults || items.length === 0'>
        <section>
            <h2>{{itemsTitle}}</h2>

            <h3 *ngIf='items !== undefined'>Cantidad: {{items.length}}</h3>

            <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
                    <div class="flex flex-wrap items-center">
                        <div class="relative w-full max-w-full flex-grow flex-1">
                            <h2 class="text-blueGray-700 text-xl font-semibold">Tópicos</h2>
                        </div>
                    </div>
                </div>
                <div class="p-4 flex-auto">
                    <div class="relative h-350">
                        <canvas id="bar-chart-topics"></canvas>
                    </div>
                </div>
            </div>

            <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
                    <div class="flex flex-wrap items-center">
                        <div class="relative w-full max-w-full flex-grow flex-1">
                            <h2 class="text-blueGray-700 text-xl font-semibold">Entidades</h2>
                        </div>
                        <p>
                            <select title="ner-select" [(ngModel)]="selectedType"
                                (ngModelChange)="onNERSelectedChanged($event)">
                                <option *ngFor="let type of commentsNerLabels">
                                    <span>{{getLongKey(type)}}</span>
                                </option>
                            </select>
                        </p>
                    </div>
                </div>
                <div class="p-4 flex-auto">
                    <div class="relative h-350">
                        <canvas id="bar-chart-ner"></canvas>
                    </div>
                </div>
            </div>

            <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
                    <div class="flex flex-wrap items-center">
                        <div class="relative w-full max-w-full flex-grow flex-1">
                            <h2 class="text-blueGray-700 text-xl font-semibold">Sentimiento</h2>
                            <h4 class="text-blueGray-700 text-xl font-semibold">
                                Se expresa en una escala del 1 al 5, donde 1 se refiere a una expresión negativa
                                mientras que 5 es una positiva.
                            </h4>
                        </div>
                    </div>
                </div>
                <div class="p-4 flex-auto">
                    <div class="relative h-350">
                        <canvas id="bar-chart-sentiment"></canvas>
                    </div>
                </div>
            </div>

        </section>

        <div *ngIf="dataSource.length > 0">
            <h2 class="mt-50">Área de filtrado de {{ itemsTitle | lowercase }}</h2>
            <app-comments-explorer class="w-full" [dataSource]="dataSource" [token]="token">
            </app-comments-explorer>
        </div>

        <!-- Comentarios
        Entidades
        Tópico
        Emociones
        Toxicidad
        Palabras claves -->
    </div>

</div>
